import { Controller, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'

export interface BasicSettingsFormValues {
  timezone: string
  dialerIsActive: boolean
}

// Props accept specific types but can be passed wider form types via type assertion
interface BasicSettingsFormProps {
  register: UseFormRegister<BasicSettingsFormValues>
  control: Control<BasicSettingsFormValues>
  errors: FieldErrors<BasicSettingsFormValues>
}

export function BasicSettingsForm({ register, control, errors }: BasicSettingsFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Basic Settings</CardTitle>
        <CardDescription>
          Configure basic campaign settings including timezone and visibility
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="timezone">Timezone</Label>
          <Input
            {...register('timezone')}
            id="timezone"
            type="text"
            placeholder="America/New_York"
          />
          {errors.timezone && (
            <p className="text-detail text-red-500">{errors.timezone.message}</p>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <Controller
            name="dialerIsActive"
            control={control}
            render={({ field }) => (
              <Checkbox
                id="dialerIsActive"
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            )}
          />
          <Label htmlFor="dialerIsActive" className="font-medium">
            Dialer is active (visible to customers)
          </Label>
        </div>
      </CardContent>
    </Card>
  )
}
